export default __webpack_public_path__ + "static/media/element_66.4080d34d.webp";